import OrdersPage from './OrdersPage';

const Page = () => <OrdersPage />;

export default Page;
